import React from "react";
import { AssetHeader } from "./Assets.styled";
import Products from "../admin/components/config/products/Products";
import DashboardLayout from "../Layout/DashboardLayout";

const ProductsManagement = () => {
  return (
    <DashboardLayout pageTitle="Sales">
      <AssetHeader data-aos="fade-right">
        <h3>Products Management</h3>
      </AssetHeader>
      <Products />
    </DashboardLayout>
  );
};

export default ProductsManagement;
